import React, { Component } from "react";
import PrestamoService from "../../../services/pagos/PrestamoService"
import { trackPromise } from 'react-promise-tracker';
import {formatoSeparadorMilesValue} from '../../generico/utils/FormatoInput'
import Popup from "react-popup";
import DatosSocio from "../../generico/DatosSocio";
import authService from "../../../services/login/auth.service";
import $ from 'jquery';
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowRight, faArrowLeft} from "@fortawesome/free-solid-svg-icons";
//// componentes reutilizables
import DataTable from 'react-data-table-component';

export default class PrestamoPaso3 extends Component {
  constructor(props) {
    super(props);    
    this.state = this.getInitialState();    
  }

  getInitialState = () => ({
    datosCuenta:[]
  })  

  componentDidMount() {
  }

  getColumn() {
    return [
    {
      name: "concepto",
      selector: row => row.concepto,
    },
    {
      name: "valor",
      selector:  row => row.valor,
    }]
  }

  obtenerDatos = (idPrestamo, cantCuotas, cuenta) =>{
   
    trackPromise(
      PrestamoService.cuotasPagar(idPrestamo, "V", cantCuotas, cuenta)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
         // console.log(jsonData)
          if (jsonData.codRespuesta === "0") {
          
            var respuesta = [
             
              {concepto: "Capital + Interés:", valor: formatoSeparadorMilesValue(jsonData.detalleVerifica[0].capitalInteres)},
              {concepto: "Interés:", valor: formatoSeparadorMilesValue(jsonData.detalleVerifica[0].interesMora)},
              {concepto: "Otros Cargos:", valor:  formatoSeparadorMilesValue(jsonData.detalleVerifica[0].otrosCargos)},
              {concepto: "Impuestos:", valor:formatoSeparadorMilesValue(jsonData.detalleVerifica[0].impuesto)},
              {concepto: "Total a Pagar:", valor:formatoSeparadorMilesValue(jsonData.detalleVerifica[0].totalAPagar)},
              {concepto: "Fecha de Operación:", valor: (new Date()).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }) }
            
            ];
         
           this.setState({ datosCuenta: respuesta });
          }
          else {
            $(".btn-cu-primary").attr("disabled","true");
            Popup.queue(this.notifiPopup("Info", jsonData.codDescripcion));
            return;
          }
        }
        ).catch(function (error) {
            authService.logout()
           //console.log(error)
          }));
}
  
notifiPopup = (titulo, mensaje) =>
Popup.register({
    title: titulo,
    content: mensaje,
    buttons: {
        right: [
            {
                text: "Aceptar",
                className: "success",
                action: function () {
                    Popup.close();
                },
            },
        ],
    },
});



  render() {
      return (
            <div>
              <div className="row">
                <div className="steps clearfix">
                  <ul role="tablist">
                    <li role="tab" className="disabled">
                      <span>
                        <div className="title">
                          <span className="title_text current">
                            Selección de Préstamo
                          </span>
                        </div>
                      </span>
                    </li>
                    <li role="tab" className="disabled">
                      <span>
                        <div className="title">
                          <span className="title_text">
                            Datos de Pago
                          </span>
                        </div>
                      </span>
                    </li>
                    <li role="tab" className="current">
                      <span>
                        <div className="title">
                          <span className="title_text">
                            Datos de Verificación
                          </span>
                        </div>
                      </span>
                    </li>
                    <li role="tab" className="disabled">
                      <span>
                        <div className="title">
                          <span className="title_text">Confirmación</span>
                        </div>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
             

              <div className="row justify-content-md-center">
                <div className="col-lg-8 col-md-10">
                <div className="form-group">
                <DatosSocio />
                  </div> 
                  <div className="form-group">
                    <label className="input-label">Prestamo N°:</label><br/> 
                    <label className="input-label-bold">{this.props.prestamo}</label>
                  </div>  
                  <div className="form-group">
                    <label className="input-label">Cuenta Origen (a debitar):</label><br/> 
                    <label className="input-label-bold">{this.props.debito}</label>                    
                  </div> 
                </div>
              </div>  

                <div className="row justify-content-md-center">
                <div className="col-lg-8 col-md-10">
                    <div className="table-responsive">
                      <DataTable
                        noHeader={true}
                        columns={this.getColumn()}
                        data={this.state.datosCuenta}
                        dense={true}
                        noDataComponent="ingrese un número de contrato para mostrar la información"
                        responsive={true}
                        noTableHead={true}/>                                
                    </div>                           
                </div>                       
                </div>
              
              <hr/>
              <div className="row">
                <div className="col-lg-8 col-md-6">
                <label className="input-label-bold" style={{marginTop:10}}>
                      Esta seguro que desea CONFIRMAR la operación?<br/>
                    </label> 
                </div>
                <div className="col-lg-2 col-md-3 btn-consulta">
                <button className="btn btn-cu-quintary"
                     onClick={this.props.previousStep}>
                    <FontAwesomeIcon icon={faArrowLeft} />  Volver
                    </button>
                </div>
                <div className="col-lg-2 col-md-3">
                <button className="btn btn-cu-primary" ref={btn => { this.btn = btn; }}
                       onClick={this.props.paso3Next}>  Confirmar <FontAwesomeIcon icon={faArrowRight} />
                    </button>
                    <button
                      hidden
                      ref={(a) => (this.nextStep = a)}
                      className="btn btn-cu-primary"
                      onClick={this.props.nextStep}>
                    </button>
                </div>
              </div>
          </div>  
      );
  }
}